import React, { PureComponent, Fragment } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import numeral from "numeral"
import { Info } from "react-feather"
import { Popover } from "antd"
import { injectIntl, FormattedMessage } from "react-intl"
import { compose } from "recompose"
import Button from "../../components/button"
import Text from "../../components/text"
import Logo from "../../components/logo"
import Box from "../../lib/ui/ui-box"
import { Media } from "../../lib/theme"
import RatesAsideForm from "../rates-aside-form"

const Aside = styled(Box)`
  position: relative;
  top: 0;
  left: 0;
  overflow-y: auto;
  height: 100%;
  display: block;
  ${Media.small`
  position: fixed;
  `};
`

const PopoverContentOne = (
  <Box flexDirection="column" w="250px">
    <Text>
      <FormattedMessage id="rates.tooltips.expertRate.p1" />
    </Text>
  </Box>
)

const PopoverContentTwo = (
  <Box flexDirection="column" w="250px">
    <Text>
      <FormattedMessage id="rates.tooltips.savings.p1" />
    </Text>

    <Text mt={[1]}>
      <FormattedMessage id="rates.tooltips.savings.p2" />
    </Text>
  </Box>
)

class RatesAside extends PureComponent {
  static propTypes = {
    bankAverageRate: PropTypes.number.isRequired
  }

  computeMonthlyPayment = rate => {
    const { propertyValue, cfMortgageType, cfLoanAmount } = this.props
    let balance
    const percentRate = Number(rate) / 100
    if (cfMortgageType === "renewal") {
      balance = Number(cfLoanAmount)
    } else {
      balance = Number(propertyValue)
    }
    const perc1 = 1 + percentRate / 12
    const pow1 = Math.pow(perc1, 12 * 25 + 1)
    const pow2 = pow1 * percentRate / 12
    return numeral(balance * pow2 / (pow1 - 1)).value()
  }

  computeSavedAmount = bankRate => {
    const { products } = this.props
    const [featured] = products
    const featuredRate = featured.rate.rate
    const withBankRate = this.computeMonthlyPayment(bankRate)
    const withFeaturedRate = this.computeMonthlyPayment(Number(featuredRate))

    return numeral((withBankRate - withFeaturedRate) * (12 * 25 + 1)).format(
      "($0,0)"
    )
  }

  render() {
    const { bankAverageRate, intl } = this.props
    return (
      <Aside
        bg="backgroundPrimary"
        w={["265px"]}
        py={[3, 2, 2]}
        flexDirection="column"
      >
        <Box flexDirection="column" align="center">
          <a href="/">
            <Logo src="/logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
          </a>
        </Box>
        <Box flexDirection="column" align="center" py={[2]} px={[2]}>
          <Text
            fontSize={[2]}
            lineHeight={[2]}
            alignText="center"
            fontWeight="700"
          >
            <FormattedMessage id="rates.aside.title" />
            <Popover
              content={PopoverContentTwo}
              title={intl.formatMessage({ id: "rates.tooltips.savings.title" })}
              placement="rightTop"
            >
              <Info size={20} color="#D8D8D8" />
            </Popover>
          </Text>
        </Box>
        <Box
          flexDirection="column"
          align="center"
          bg="actionGreen"
          borderWidth="4px"
          borderColor="actionGreen"
          py={[2]}
          mt={[2]}
          px={[1]}
        >
          <Fragment>
            <Text
              fontSize={[5]}
              lineHeight={[5]}
              color="white"
              fontWeight="700"
            >
              {this.computeSavedAmount(bankAverageRate)}
            </Text>
            <Text fontSize={[1]} lineHeight={[1]} color="white">
              <FormattedMessage
                id="rates.aside.subtitle"
                values={{
                  rate: bankAverageRate
                }}
              />
            </Text>
          </Fragment>
        </Box>

        <Box flexDirection="column" pt={[2]} px={[2]}>
          <Text fontSize={[1]}>
            <FormattedMessage id="rates.aside.info_title" />
          </Text>
          <RatesAsideForm {...this.props} />

          <Box flexDirection="column" justify="center" align="center" pt={[2]}>
            <Text>
              <FormattedMessage id="rates.aside.info_p1" />
            </Text>
            <Text pt={[1]}>
              <FormattedMessage id="rates.aside.info_p2" />
              <Popover
                content={PopoverContentOne}
                title={intl.formatMessage({
                  id: "rates.tooltips.expertRate.title"
                })}
                placement="rightTop"
              >
                <Info size={20} color="#D8D8D8" />
              </Popover>
            </Text>

            <a
              href={`tel:${intl.formatMessage({
                id: "nav.numberFormatted"
              })}`}
            >
              <Button
                bg="actionPrimary"
                mt={[2]}
                px={[1]}
                w="100%"
                align="center"
                justify="center"
              >
                <Text fontWeight="700" fontSize={[0]} color="white">
                  <FormattedMessage id="rates.aside.cta_call" />
                </Text>
              </Button>
            </a>
            <a
              href={`tel:${intl.formatMessage({
                id: "nav.numberFormatted"
              })}`}
            >
              <Text
                fontSize={[1]}
                onClick={() =>
                  window.analytics.track("Clicked to Call", {
                    location: "rates-aside",
                    text: "613-769-9213",
                    type: "phone number"
                  })
                }
                fontWeight="700"
                color="text"
                mt={[2]}
              >
                <FormattedMessage id="nav.number" defaults="613-769-9213" />
              </Text>
            </a>
          </Box>
        </Box>
      </Aside>
    )
  }
}

export default compose(injectIntl)(RatesAside)



// WEBPACK FOOTER //
// ./src/components/rates-aside/rates-aside.component.js